import { jsx as _jsx } from "react/jsx-runtime";
import { SvgIcon } from '@mui/material';
import { forwardRef, memo, Suspense } from 'react';
const CustomIcon = memo(forwardRef((props, ref) => {
    const { Icon, width = '1em', height = '1em', fill, fillOpacity, fontSize = '1em', viewBox = '0 0 32 32', ...rest } = props;
    return (_jsx(SvgIcon, { sx: { fontSize, width, height, ...rest.sx }, viewBox: viewBox, ...rest, ref: ref, children: Icon && (_jsx(Suspense, { fallback: _jsx("div", {}), children: _jsx(Icon, { width: "100%", height: "100%", fill: fill, fillOpacity: fillOpacity }) })) }));
}));
CustomIcon.displayName = 'CustomIcon';
export { CustomIcon };
